module.exports = __webpack_public_path__ + "media/images/icons/talk-017342bd296cccee26b17844b5681718.svg";